import { Factory } from 'rosie';

import random from '../random';

const optionLabels = [
  'Trousers',
  'Jackets',
  'Lingerie',
  'Boys',
  'Girls',
  'Suits',
  'Jeans',
  'Skirts',
  'Coats',
  'Shirts',
];

const OptionFactory = new Factory()
  .attr('label', () => random.pickone(optionLabels))
  .attr('id', () => random.guid({ version: 4 }));

export default OptionFactory;
